import { render, staticRenderFns } from "./MyIntroduce5.vue?vue&type=template&id=14618cca&scoped=true"
import script from "./MyIntroduce5.vue?vue&type=script&lang=js"
export * from "./MyIntroduce5.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce5.vue?vue&type=style&index=0&id=14618cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14618cca",
  null
  
)

export default component.exports